import { createReducer } from 'typesafe-actions'
import VinCodeDataStatus from '../../entities/VinStatus'
import { resetVinDataStatusState, setVinDataStatusState } from '../actions/app/vin.actions'

export type VinDataStatusState = VinCodeDataStatus

export const defaultState: VinDataStatusState = {
    status: null,
    rescueInfo: null,
    vinModelName: null,
    models: null,
    alternatives: null,
    vinCode: null,
}

const vinStatusDataReducer = createReducer(defaultState)
    .handleAction(setVinDataStatusState, (state, action) => action.payload)
    .handleAction(resetVinDataStatusState, (() => defaultState))

export default vinStatusDataReducer
